// ###### IMPORTS
import React from 'react';
import { toast } from 'react-hot-toast';
import { useNotepadViewMode } from '../viewServices/useNotepadViewMode';
import DropdownViewMode from '../../moduleComponents/DropdownViewMode';

// ###### COMPONENT
const CardViewMode = () => {
  const { viewMode, setViewMode } = useNotepadViewMode();

  // ###### HANDLERS
  const handleViewModeChange = (newMode) => {
    setViewMode(newMode);
    const modeLabel = newMode === 'title-only' ? 'Title Only' : 'Preview';
    toast.success(`Display mode changed to "${modeLabel}"`);
  };

  return (
    <div className="bg-white rounded-xl shadow p-4">
      <h3 className="text-lg font-semibold text-gray-800 mb-3">Display Mode</h3>
      <div className="space-y-2">
        <p className="text-sm text-gray-600">
          Choose how notes are displayed in the notes grid.
        </p>
        <DropdownViewMode 
          viewMode={viewMode} 
          onSelect={handleViewModeChange}
          width="w-full"
        />
        <div className="text-xs text-gray-500 mt-2 space-y-1">
          <div className="flex items-center gap-2">
            <span className="font-medium">Title Only:</span>
            <span>Shows only the note title and date</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="font-medium">Preview:</span>
            <span>Shows title, date, and content preview</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardViewMode;
